__turbopack_context__.v({
  "className": "playfair_display_5f993524-module__QG2fTa__className",
  "variable": "playfair_display_5f993524-module__QG2fTa__variable",
});
